'use client';

import { useState, type ReactNode } from 'react';

import { Dialog, DialogContent, DialogTrigger } from '../../shared/Dialog';
import {
  EventTimelineEntry,
  type EventTimelineEntryProps,
} from '../../shared/EventTimelineEntry';
import { FlightOverview } from '../FlightOverview';

import type { FlightOverviewProps } from '../FlightOverview';

export type DashboardTravelItineraryTimelineEntryProps = {
  timelineProps: EventTimelineEntryProps;

  variant?: 'flight-details';

  // TODO enhance dialog props
  dialog?: {
    trackingName?: string;

    title?: string;
    content?: ReactNode;
  };

  flightOverviewProps?: FlightOverviewProps;
};

export const DashboardTravelItineraryTimelineEntry = ({
  timelineProps,
  dialog,
  variant,
  flightOverviewProps,
}: DashboardTravelItineraryTimelineEntryProps) => {
  const t = (str: string) => str; // Replace with actual translation function
  const [isDetailsShown, setDetailsShown] = useState(false);

  const isFlightDetails = variant === 'flight-details';

  if (dialog || isFlightDetails) {
    if (isFlightDetails && !flightOverviewProps) return null;

    return (
      <Dialog trackingName={dialog?.trackingName}>
        <EventTimelineEntry
          {...timelineProps}
          {...(isFlightDetails
            ? {
                mainCta: {
                  ...timelineProps.mainCta,
                  asChild: true,
                  children: (
                    <DialogTrigger>
                      {timelineProps.mainCta?.children}
                    </DialogTrigger>
                  ),
                },
              }
            : {
                secondaryCta: {
                  asChild: true,
                  children: <DialogTrigger>{t('mehr...')}</DialogTrigger>,
                },
              })}
        />
        <DialogContent
          title={
            dialog?.title ?? (isFlightDetails ? t('Flugdetails') : undefined)
          }
          disableSpacing
          overlayClassName={isDetailsShown ? 'hidden' : undefined}
        >
          <div className="bg-white text-marine-high-emphasis">
            {isFlightDetails && flightOverviewProps && (
              <div className="p-6">
                <FlightOverview
                  {...flightOverviewProps}
                  onDetailsOpenChange={isDetailsOpen =>
                    setDetailsShown(isDetailsOpen)
                  }
                />
              </div>
            )}

            {dialog?.content}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return <EventTimelineEntry {...timelineProps} />;
};
